import { render, staticRenderFns } from "./GameCardBody.vue?vue&type=template&id=b15b9736&scoped=true&"
import script from "./GameCardBody.vue?vue&type=script&lang=js&"
export * from "./GameCardBody.vue?vue&type=script&lang=js&"
import style0 from "./GameCardBody.vue?vue&type=style&index=0&id=b15b9736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15b9736",
  null
  
)

export default component.exports